import {
  Button,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import { ChevronDown, Search } from "lucide-react";
import { useContext, useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { DatabaseDropdownContext } from "../../../context/DatabaseDropdownContext";

export default function DatabaseDropdownFields() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { setIsDragging, setShowCursor } = useContext(DatabaseDropdownContext);
  const [ column_names, setColumn_names ] = useState(null);

  // const allNames = Array.from({ length: 100 }, (_, i) => `Name_${i + 1}`);
  const allNames = column_names ? column_names : [];
  const filteredNames = allNames.filter((name) =>
    name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const open = Boolean(anchorEl);
  const handleDropdownClick = (e) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget)
  };
  const handleDropdownClose = () => {
    setAnchorEl(null);
    setSearchTerm("");
  };

  const handleDragStart = (e, name) => {
    e.dataTransfer.setData("text/plain", `{{${name}}}`);

     // --- FIX: Custom drag ghost image ---
    const ghost = document.createElement("div");
    ghost.textContent = name;
    ghost.style.position = "absolute";
    ghost.style.top = "-99999px";
    ghost.style.padding = "4px 8px";
    ghost.style.background = "#eee";
    ghost.style.border = "1px solid #ccc";
    ghost.style.borderRadius = "4px";
    ghost.style.fontSize = "14px";
    ghost.style.pointerEvents = "none";

    document.body.appendChild(ghost);
    e.dataTransfer.setDragImage(ghost, 0, 0);

    // Remove ghost immediately after browser picks it up
    setTimeout(() => document.body.removeChild(ghost), 0);
    // ------------------------------------

    setIsDragging(true);
    handleDropdownClose();
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    setShowCursor(false);
  };

  useEffect(() => {
    const data = localStorage.getItem("column_data")
    const data1 = JSON.parse(data)
    if (data1.column_names) {
      setColumn_names(data1.column_names);
    }
  }, []);

  return (
    <div>
      {/* Dropdown Button */}
      <Button
        variant="contained"
        onClick={handleDropdownClick}
        endIcon={<ChevronDown />}
        sx={{
          textTransform: "none",
          padding: "4px 7px",
          background: "linear-gradient(135deg,#667eea,#764ba2)",
        }}
      >
        Database Column
        ({allNames.length})
      </Button>

      {/* Dropdown */}
      <Menu anchorEl={anchorEl} open={open} onClose={handleDropdownClose}>
        <div className="px-3 pb-3 sticky top-0 bg-white z-10 border-b border-gray-200">
          <TextField
            size="small"
            fullWidth
            placeholder="Search names..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search className="w-4 h-4 text-gray-400" />
                </InputAdornment>
              ),
            }}
          />
        </div>

        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
          {filteredNames.map((name, i) => (
            <MenuItem
              key={i}
              draggable
              onDragStart={(e) => handleDragStart(e, name)}
              onDragEnd={handleDragEnd}
            >
              {name}
            </MenuItem>
          ))}
        </div>
      </Menu>
    </div>
  );
}
